import { StyledTemplateBanner } from './styled';

const TemplateBanner = () => (
  <StyledTemplateBanner>
    <h1 className="cta-heading">Explore Poll & Micro-survey templates</h1>
    <div className="lead">Explore, pick, and customize templates to your needs.</div>
  </StyledTemplateBanner>
);

export default TemplateBanner;
